module.exports = __webpack_public_path__ + "img/good_casper_white.63ac23e1.svg";